/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Player_Video_Lock_TitleInputs */

const en_player_video_lock_title = /** @type {(inputs: Player_Video_Lock_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lock Video to CC`)
};

const fr_player_video_lock_title = /** @type {(inputs: Player_Video_Lock_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verrouiller la Video sur CC`)
};

const de_player_video_lock_title = /** @type {(inputs: Player_Video_Lock_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Video auf CC sperren`)
};

const it_player_video_lock_title = /** @type {(inputs: Player_Video_Lock_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Blocca video su CC`)
};

const ru_player_video_lock_title = /** @type {(inputs: Player_Video_Lock_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Скрыть видео с субтитрами`)
};

const es_player_video_lock_title = /** @type {(inputs: Player_Video_Lock_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bloquear vídeo en CC`)
};

const zh_cn2_player_video_lock_title = /** @type {(inputs: Player_Video_Lock_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`锁定视频至CC`)
};

const ja_player_video_lock_title = /** @type {(inputs: Player_Video_Lock_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ビデオをCCにロックする`)
};

const hi_player_video_lock_title = /** @type {(inputs: Player_Video_Lock_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`वीडियो को सीसी पर लॉक करें`)
};

const pt_pt2_player_video_lock_title = /** @type {(inputs: Player_Video_Lock_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bloquear vídeo para legendas`)
};

/**
* | output |
* | --- |
* | "Lock Video to CC" |
*
* @param {Player_Video_Lock_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const player_video_lock_title = /** @type {((inputs?: Player_Video_Lock_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Player_Video_Lock_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_player_video_lock_title(inputs)
	if (locale === "de") return de_player_video_lock_title(inputs)
	if (locale === "it") return it_player_video_lock_title(inputs)
	if (locale === "ru") return ru_player_video_lock_title(inputs)
	if (locale === "es") return es_player_video_lock_title(inputs)
	if (locale === "zh-CN") return zh_cn2_player_video_lock_title(inputs)
	if (locale === "ja") return ja_player_video_lock_title(inputs)
	if (locale === "hi") return hi_player_video_lock_title(inputs)
	if (locale === "pt-PT") return pt_pt2_player_video_lock_title(inputs)
	return en_player_video_lock_title(inputs)
});